// removed by extract-text-webpack-plugin
module.exports = {"root":"_3010PEV","message":"_7Z-RZfL","message_saved":"_2NtXyXv","message_exceeded":"MyBOnTY","message_error":"_9D7_Qjt","messageIcon":"AVOtoxh","messageIconSvg":"_2yAInYP","textContainer":"_1xYUm8a","description":"_2kr-tsT","edit":"_3hY-9C4","saveButton":"_35uAGUu","saveIconSvg":"BQ0TVpA","title":"_1QJgjbL"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/SaveSearch/SaveSearch.less
 ** module id = 878
 ** module chunks = 0
 **/